import { StandaloneComponent } from '@/types/component';
import { getSite } from '@/utils/getSite';
import { getOcelotConfig } from 'lib/configs/ocelot';
import Head from 'next/head';
import Script from 'next/script';
export const StandaloneConsent: StandaloneComponent = () => {
  const site = getSite();
  const isSvenskDamOrHant = ['svenskdam', 'hant'].includes(site);
  const didomiSeNoticeid = getOcelotConfig('cmp.didomi_notice_id');
  const didomiSeApiKey = getOcelotConfig('cmp.didomi_api_key');
  const consentVersion = isSvenskDamOrHant ? `2.3.15${site}` : '2.4.1';
  const consentBasePath = `/common/js`;
  const consentPath = `${consentBasePath}/consent`;
  const componentVersion = '05';
  const cacheBuster = `v=${consentVersion}-${componentVersion}`;
  const didomiCMpPath = `${consentBasePath}/cmp/didomi.js?${cacheBuster}`;

  const allerConsentUrl = `${consentPath}/consent-${consentVersion}.js`;
  const didomiCustomConfPath = `${consentBasePath}/cmp/didomi-custom.js?${cacheBuster}`;

  const preload = getOcelotConfig('ads.preload.enabled');

  if (process.env.CONSENT_DISABLED === 'true') {
    return null;
  }

  return (
    <>
      <Head>
        {/* Always preload tcf stub and otStub */}
        {<link rel="preload" href={didomiCMpPath} as="script" />}
        {<link rel="preload" href={didomiCustomConfPath} as="script" />}

        {preload && (
          <>
            <link rel="preload" href={allerConsentUrl} as="script" />
          </>
        )}
      </Head>
      {<Script src={didomiCustomConfPath} data-api-key={didomiSeApiKey} data-notice-id={didomiSeNoticeid} /> }
      {<Script src={didomiCMpPath} data-api-key={didomiSeApiKey} data-notice-id={didomiSeNoticeid} /> }
      {/* Aller consent library */}
      <Script src={allerConsentUrl} />
    </>
  );
};
